import { render, staticRenderFns } from "./AppPlaceAutocomplete.vue?vue&type=template&id=d9a51f1a&"
import script from "./AppPlaceAutocomplete.vue?vue&type=script&lang=js&"
export * from "./AppPlaceAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconCircle: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconCircle.vue').default})
